// extracted by mini-css-extract-plugin
export var boardMembers = "Card-module--boardMembers---kzjE";
export var card = "Card-module--card--VbGzj";
export var cardBody = "Card-module--card-body--aeBIP";
export var cardImageWrapper = "Card-module--card-image-wrapper--08fil";
export var primary = "#06004d";
export var regularTeam = "Card-module--regularTeam--u6jiu";
export var secondary = "#4dafd7";